import { login } from 'store/auth/actions/login'
import { logout } from 'store/auth/actions/logout'
import { AuthSlice } from 'store/auth/slice'

export const AuthActions = {
  ...AuthSlice.actions,
  login,
  logout,
}
